import React from "react";
import styles from "./MobileBlock.module.css";

const MobileBlock = (): React.JSX.Element => {
  return (
    <div className={styles["mobile-block"]}>
      <div className={styles["card"]}>
        <h1 className={styles["title"]}>📱 Mobile Access Restricted</h1>
        <p className={styles["primary-text"]}>
          HallHero must be accessed from a desktop or laptop computer.
        </p>
        <p className={styles["secondary-text"]}>
          Please use a school computer or Chromebook to request hall passes.
        </p>
        <hr className={styles["divider"]} />
        <p className={styles["footer-text"]}>
          If you are a teacher or administrator, please use the appropriate
          login.
        </p>
      </div>
    </div>
  );
};

export default MobileBlock;
